(ns frontend.actions.reports
  (:require
   [promesa.core :as p]
   [frontend.conn :as conn]
   [frontend.logging :as logging]))

(defn *->deals-per-tag-status-and-stage
  [data on-success! on-error!]
  (-> (conn/sendp! :report/deals-per-tag-status-and-stage data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->deals-throughput
  [data on-success! on-error!]
  (-> (conn/sendp! :report/deals-throughput data 60000)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->deal-activities
  [on-success! on-error!]
  (-> (conn/sendp! :reports/deals-activities {} 60000)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->fund-commit-contacts
  []
  (-> (conn/sendp! :reports/custom-fund-commit-contacts
                   {}
                   60000)
      (p/then (fn [resp]
                (let [body (:body resp)
                      url (:download-url body)
                      w (when url (.open js/window "about:blank" "_blank"))]
                  (when w
                    (aset w "location" (:download-url body))))))
      (p/catch (fn [e]
                 (logging/log "REPORT ERROR : " e)))))
